import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import VuexPersistence from 'vuex-persist'
import {createStore} from 'vuex-extensions'

// If significant changes are made to vuex structures, bump version to force refreshing state
const key = `vma5`
let cachedCompanyAddresses = []

const vuexLocal = new VuexPersistence({
  key,
  storage: {
    getItem: (key) => {
      const data = localStorage.getItem(key)
      const parsedData = data ? JSON.parse(data) : null
      // this shouldn't happen, since we wouldn't load from localStorage
      // without having lost the process memory, but just to be safe
      if (cachedCompanyAddresses.length && parsedData?.company) {
        parsedData.company.selected_company_addresses = cachedCompanyAddresses
      }
      return parsedData
    },
    setItem: (key, value) => {
      let newState = JSON.parse(JSON.stringify(value)) // Clone to avoid mutation issues
      if (typeof newState !== "object" || newState === null) newState = JSON.parse(newState)

      // TODO: actually move company addresses to a separate module and do not persist
      if (newState?.company?.selected_company_addresses) {
        cachedCompanyAddresses = newState.company.selected_company_addresses
        delete newState.company.selected_company_addresses
      }

      // Don't persist large order datasets to avoid localStorage quota issues
      if (newState?.order?.invoices) {
        delete newState.order.invoices
      }

      // Live source-lot inventory must not freeze across reloads.
      if (newState?.upstreamMasterLots?.upstreamSourceLotsCacheByMetals) {
        newState.upstreamMasterLots.upstreamSourceLotsCacheByMetals = {}
      }

      // Save the new state
      localStorage.setItem(key, JSON.stringify(newState))
    },
    removeItem: (key) => {
      localStorage.removeItem(key)
    },
    clear: () => {
      localStorage.clear()
    },
  },
  modules: ['app', 'auth', 'cart', 'order', 'query', 'company', 'rating', 'experiment', 'transaction', 'refinery', 'refineryConfig', 'adminMode', 'uiPreferences', 'shipsecure', 'upstreamMasterLots', 'upstreamContracts'],
})

Vue.use(Vuex)

const store = createStore(Vuex.Store, {
  modules,
  plugins: [vuexLocal.plugin],
})


store.resetState = () => {
  vuexLocal.storage.clear()
}

export default store
